import React from "react";
import { Star } from "lucide-react";

export default function SaasTestimonials() {
  const testimonials = [
    {
      quote: "Migrating our 12 coaching centers to Skillzy's white-label LMS was a massive success. The subdomains set up instantly and parent satisfaction is at an all-time high.",
      author: "Rajesh K. Singhal",
      role: "Founder, Singhal Classes",
      type: "Institute Owner",
      img: "https://i.pravatar.cc/120?img=11",
      color: "border-violet-500/30"
    },
    {
      quote: "The AI exam creator saves me hours of paper setting. Standard and subjective exam grading combined with stylus annotations is exactly what we needed.",
      author: "Dr. Shreya Mehta",
      role: "HOD Physics, St. Xavier College",
      type: "Teacher",
      img: "https://i.pravatar.cc/120?img=5",
      color: "border-blue-500/30"
    },
    {
      quote: "The student app is awesome. I can download lectures and use the AI tutor to clear mathematical formulas while commuting to coaching centers.",
      author: "Aarav Saxena",
      role: "JEE Aspirant",
      type: "Student",
      img: "https://i.pravatar.cc/120?img=12",
      color: "border-cyan-500/30"
    }
  ];

  return (
    <section className="py-24 bg-white dark:bg-slate-950 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 dark:text-white tracking-tight">
            Loved by Owners, Teachers & Students
          </h2>
          <p className="mt-4 text-lg text-slate-600 dark:text-slate-300 font-medium">
            Read success stories from institutes that scaled their digital footprint using the Skillzy platform.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((item) => (
            <div
              key={item.author}
              className={`bg-slate-50 dark:bg-slate-900/60 p-8 rounded-[2.5rem] border ${item.color} shadow-sm flex flex-col justify-between hover:shadow-xl transition-all duration-300 group`}
            >
              <div>
                {/* Five star rating */}
                <div className="flex text-amber-400 gap-1 mb-6">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <Star key={s} size={14} fill="currentColor" />
                  ))}
                </div>
                
                {/* Quote */}
                <p className="text-sm italic text-slate-700 dark:text-slate-200 leading-relaxed font-medium">
                  "{item.quote}"
                </p>
              </div>

              {/* Author Info */}
              <div className="flex items-center gap-4 mt-8 border-t border-slate-100 dark:border-slate-800 pt-6">
                <img
                  src={item.img}
                  alt={item.author}
                  className="w-12 h-12 rounded-full border-2 border-white dark:border-slate-800 object-cover"
                />
                <div>
                  <h4 className="font-extrabold text-sm text-slate-900 dark:text-white leading-tight">
                    {item.author}
                  </h4>
                  <p className="text-[10px] text-slate-450 dark:text-slate-500 font-semibold mt-0.5">
                    {item.role}
                  </p>
                  <span className="inline-block px-2 py-0.5 bg-violet-100 dark:bg-violet-950/40 text-violet-600 dark:text-violet-400 text-[8px] font-black rounded-full uppercase mt-1.5">
                    {item.type}
                  </span>
                </div>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
